import { Link } from 'react-router-dom';
import { LayoutGrid } from 'lucide-react';

interface AllAppsLinkProps {
  count: number;
}

// Compact "Browse all → " row for variants that demote the full apps grid.

export const AllAppsLink = ({ count }: AllAppsLinkProps) => (
  <Link
    to="/apps"
    className="group flex min-h-11 items-center justify-between gap-3 rounded-xl border border-dashed border-line bg-bg-primary px-4 py-3 transition-colors hover:border-brand-navy/40 hover:bg-bg-secondary"
  >
    <span className="flex items-center gap-3">
      <span className="grid h-8 w-8 place-items-center rounded-lg bg-bg-secondary text-text-secondary group-hover:text-brand-navy">
        <LayoutGrid className="h-4 w-4" aria-hidden="true" />
      </span>
      <span className="text-sm">
        Browse all <span className="font-semibold text-text-primary">{count}</span> apps
      </span>
    </span>
    <span className="text-xs text-accent transition-transform group-hover:translate-x-0.5">→</span>
  </Link>
);
